<script>
export default {
	render(h) {
		return (
			<div class="container hidden-xs-only">
			<el-breadcrumb separator="/" class="crumb">
				<el-breadcrumb-item to={{ path: "/" }}>首页</el-breadcrumb-item>
				{this.crumbList.map(i => {
					return (
						<el-breadcrumb-item>{i.meta.title}</el-breadcrumb-item>
					);
				})}
			</el-breadcrumb>
			</div>
		);
	},
	computed: {
		crumbList() {
			return this.$route.matched;
		}
	}
};
</script>
<style lang="scss" scoped>
.crumb {
	font-size: 16px;
	line-height: 60px;
	border-bottom: 1px solid #e1e1e1;
	margin-bottom: 20px;
}
</style>
